import { useState } from 'react';
import { squaredToValue } from '../lib/helpers';

export const useInputControls = (sendCommand) => {
    // Input controls with default values
    const [mixSlider, setMixSlider] = useState(0);  // Start with synth only
    const [attackSlider, setAttackSlider] = useState(Math.sqrt((10 - 1) / (1000 - 1)));  // 10ms default
    const [releaseSlider, setReleaseSlider] = useState(Math.sqrt((100 - 1) / (2000 - 1)));  // 100ms default
    const [filterModSlider, setFilterModSlider] = useState(0);

    // Handlers
    const handleMixChange = (sliderPos) => {
        setMixSlider(sliderPos);
        sendCommand('input.mix', sliderPos.toFixed(3));
    };

    const handleAttackChange = (sliderPos) => {
        setAttackSlider(sliderPos);
        const actualValue = squaredToValue(sliderPos, 1, 1000);
        sendCommand('input.attack', actualValue.toFixed(1));
    };

    const handleReleaseChange = (sliderPos) => {
        setReleaseSlider(sliderPos);
        const actualValue = squaredToValue(sliderPos, 1, 2000);
        sendCommand('input.release', actualValue.toFixed(1));
    };

    const handleFilterModChange = (sliderPos) => {
        setFilterModSlider(sliderPos);
        sendCommand('filter.mod', sliderPos.toFixed(3));
    };

    // Computed actual values
    const mixActual = mixSlider;  // Linear 0-1
    const attackActual = squaredToValue(attackSlider, 1, 1000);
    const releaseActual = squaredToValue(releaseSlider, 1, 2000);
    const filterModActual = filterModSlider;  // Linear 0-1

    return {
        // Values
        mixSlider,
        mixActual,
        attackSlider,
        attackActual,
        releaseSlider,
        releaseActual,
        filterModSlider,
        filterModActual,

        // Handlers
        handleMixChange,
        handleAttackChange,
        handleReleaseChange,
        handleFilterModChange
    };
};
